import * as ClientConfig from "../config/ClientConfig.js";
//analytics
import {initializeApp} from "firebase/app";
import {getAnalytics, logEvent} from "firebase/analytics";
import * as StorageService from "./StorageService";
import {LOCALSTORAGE_ITEMS} from "../util/Constants";

const firebaseConfig = {
    apiKey: ClientConfig.REACT_APP_FIREBASE_API_KEY,
    authDomain: ClientConfig.REACT_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: ClientConfig.REACT_APP_FIREBASE_DATABASE_URL,
    projectId: ClientConfig.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: ClientConfig.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: ClientConfig.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: ClientConfig.REACT_APP_FIREBASE_APP_ID,
    measurementId: ClientConfig.REACT_APP_FIREBASE_MEASURMENT_ID
};
// Initialize Firebase
let app = null;
let analytics = null;
let analyticsInitialized = false;
function analyticsLogEvent(...event){
    const userAcceptedCookies = StorageService.getItem(LOCALSTORAGE_ITEMS.USER_ACCEPTED_COOKIES);
    if(!!userAcceptedCookies) {
        if(userAcceptedCookies === "true") {
            if (!analyticsInitialized) {
                analyticsInitialized = true;
                app = initializeApp(firebaseConfig);
                analytics = getAnalytics(app);
            }
            logEvent(analytics, ...event);
        }
    }
}
export default analyticsLogEvent;
